export const environment = {
  production: true,
  baseUrl: 'https://tourism.egyptumrah.com',

  tourismBaseUrl: 'https://tourism.egyptumrah.com/',
  tourismApi: 'https://tourism.egyptumrah.com/api',

  ministryApi: 'https://ministry.egyptumrah.com/api',
  ministryBaseUrl: 'https://ministry.egyptumrah.com/',

  bankingApi: 'https://banking.egyptumrah.com/api',
  bankingBaseUrl: 'https://banking.egyptumrah.com/',

  interiorApi: 'https://interior.egyptumrah.com/api',
  interiorBaseUrl: 'https://interior.egyptumrah.com/',

  mohApi: 'https://moh.egyptumrah.com/api',
  mohBaseUrl: 'https://moh.egyptumrah.com/',

  cabinetApi: 'https://cabinet.egyptumrah.com/api',
  cabinetBaseUrl: 'https://cabinet.egyptumrah.com/',

  iftaApi: 'https://ifta.egyptumrah.com/api',
  iftaBaseUrl: 'https://ifta.egyptumrah.com/',

  cbeApi: 'https://cbe.egyptumrah.com/api',
  cbeBaseUrl: 'https://cbe.egyptumrah.com/',

  etaaApi: 'https://etaa.egyptumrah.com/api',
  etaaBaseUrl: 'https://etaa.egyptumrah.com/',

  saudiAgentApi: 'https://saudi-agent.egyptumrah.com/api',
  saudiAgentBaseUrl: 'https://saudi-agent.egyptumrah.com/',

  taxAgencyApi: 'https://tax-agency.egyptumrah.com/api',
  taxAgencyBaseUrl: 'https://tax-agency.egyptumrah.com/',

  foreignAffairsApi: 'https://foreign-affairs.egyptumrah.com/api',
  foreignAffairsBaseUrl: 'https://foreign-affairs.egyptumrah.com/',

  transportersApi: 'https://transporters.egyptumrah.com/api',
  transportersBaseUrl: 'https://transporters.egyptumrah.com/',

  consulateApi: 'https://consulate.egyptumrah.com/api',
  consulateBaseUrl: 'https://consulate.egyptumrah.com/',

  tourismCompaniesApi: 'https://tourism-companies.egyptumrah.com/api',
  tourismCompaniesBaseUrl: 'https://tourism-companies.egyptumrah.com/',

  hotelsApi: 'https://hotels.egyptumrah.com/api',
  hotelsBaseUrl: 'https://hotels.egyptumrah.com/',

  hotelGateApi: 'https://hotelgate.egyptumrah.com/api',
  hotelGateBaseUrl: 'https://hotelgate.egyptumrah.com/',

  statisticsApi: 'https://statistics.egyptumrah.com/api',
  statisticsBaseUrl: 'https://statistics.egyptumrah.com/',

  citizensApi: 'https://back.umrah.eg/api',
  citizensBaseUrl: 'https://back.umrah.eg/',

  secret_key: 'JRtJfhqvvB80tzA9e0cCNNR8VpfCoIKg',
  secret_iv: '6CDD64E216E26EE312A88A54BB636',
  token: localStorage.getItem('__ms_t_'),
};
